<template>
	<div>
		<video class="bg-video" src="/footage/dal.mp4" autoplay muted loop></video>
		<router-link :to="{name:'yaprak-yakin'}" class="page-nav-link" id="link-left"><img class="link-image" src="images/arrow-up-white-01.png" alt=""></router-link>


	</div>
</template>
<script>
	import CircleLink from "../components/CircleLink"
	import _ from 'lodash'

	export default {
		name: "DalPage",
		components: {CircleLink},
		computed: {
			pageLinks: function () {
				var thisPagesLinks = _.find(this.$store.state.linksCollection, {'pageName': 'agac'})
				return thisPagesLinks.pageLinks
			}
		}
	}
</script>

<style scoped>
	.bg-video {
		top: 0;
		left: 0;
		position: absolute;
		object-fit: cover;
		width: 100%;
		height: 100%;
		z-index: -2;
	}
</style>